import { STATUS_ACTIVE } from "@/constants/products";

export default {
  type: "products",
  name: null,
  sku: null,
  status: STATUS_ACTIVE,
  excerpt: "",
  buying_price: null,
  selling_price: null,
  picture: null,
  gallery: [],
  taxGroups: [],
  can_be_sold: false,
  can_be_purchased: false,
  relationshipNames: [
    "organization",
    "allowedLocations",
    "categories",
    "taxGroups",
    "unitOfMeasure",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  unitOfMeasure: {
    type: "unit-of-measures",
    id: null,
  },
  allowedLocations: [],
  categories: [],
};
